export async function speakText(text: string): Promise<void> {
  if (!text) return;

  if (typeof window === 'undefined' || typeof window.speechSynthesis === 'undefined') {
    throw new Error('Text-to-speech is not supported in this environment');
  }

  const utterance = new SpeechSynthesisUtterance(text);
  window.speechSynthesis.cancel();
  window.speechSynthesis.speak(utterance);

  // Wait for speech completion or immediate resolve if event unavailable
  await new Promise<void>((resolve, reject) => {
    const cleanup = () => {
      utterance.removeEventListener('end', handleEnd);
      utterance.removeEventListener('error', handleError);
    };

    const handleEnd = () => {
      cleanup();
      resolve();
    };

    const handleError = (event: SpeechSynthesisErrorEvent) => {
      cleanup();
      reject(new Error(event.error || 'Speech synthesis failed'));
    };

    utterance.addEventListener('end', handleEnd);
    utterance.addEventListener('error', handleError);

    // Fallback resolve after short timeout to avoid hanging if events are not firing
    setTimeout(() => {
      cleanup();
      resolve();
    }, 100);
  });
}
